/**
 * زیرِ پیامی که مدیر پنهان کرد (WHOSUP-309، مایگریشن 0175) — فقط فرستنده
 * آن پیام را می‌بیند (RLS)، پس فقط او این را می‌بیند. قرینه‌ی
 * apps/mobile/src/features/signals/HeldMessageNote.tsx.
 */
import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { signalRepo } from '@/core/data/signalRepo';
import { t } from '@/core/lib/i18n';
import { reportError } from '@/core/lib/report';
import type { Message } from '@/core/domain/types';

export function HeldMessageNote({ m }: { m: Message }) {
  const qc = useQueryClient();
  const appeal = useMutation({
    mutationFn: () => signalRepo.appealHeldMessage(m),
    onSuccess: () => {
      window.alert(t('filterAppealSent'));
      qc.invalidateQueries({ queryKey: ['messages', m.signalId] });
    },
    onError: (e) => { reportError('web.chat.appealHeld', e); window.alert(t('errorRetry')); },
  });
  const open = m.heldAppealStatus === 'open';
  return (
    <div className="dim" style={{ fontSize: 13 }}>
      <div>⛔ {t('modHeldBody', { reason: m.heldReason ?? '' })}</div>
      {m.heldFix ? <div>{t('modHeldFix', { fix: m.heldFix })}</div> : null}
      {open ? <div>{t('modHeldAppealOpen')}</div> : null}
      {m.heldAppealStatus === 'upheld' ? <div>{t('modHeldAppealUpheld')}</div> : null}
      {!open ? (
        <button type="button" className="btn" disabled={appeal.isPending}
          onClick={() => appeal.mutate()}>{t('filterAppeal')}</button>
      ) : null}
    </div>
  );
}
